// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","imageContainer":"Card_imageContainer__5xKWZ","state":"Card_state__bE3nR","details":"Card_details__ez44D"};